import React, {useState, useEffect} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';

function Options() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      const parsedUser = JSON.parse(user);
      console.log('user here', parsedUser);
      setUser(parsedUser);
    }
  }, []);

  return (
    <div style={{backgroundColor: '#E6DBBA', minHeight: '100vh'}}>
      <div style={{position: 'relative'}}>
        <img
          src="/images/options.jpg"
          alt="Options"
          style={{
            width: '100%',
            height: '100vh',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
          }}></div>

        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            zIndex: 2,
            padding: '0 20px',
          }}>
          <h1 style={styles.title}>Welcome to the Game</h1>

          <button style={styles.button} onClick={() => navigate('/home')}>
            Play
          </button>

          <button
            style={{...styles.button, ...styles.aiButton}}
            onClick={() => navigate('/playai')}>
            Play with AI
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  title: {
    fontSize: '32px',
    color: '#FF7010',
    fontWeight: 'bold',
    marginBottom: '50px',
    textAlign: 'center',
    textShadow: '1px 1px 5px #000',
  },
  button: {
    width: '80%',
    backgroundColor: '#FF7010',
    padding: '16px 0',
    borderRadius: '16px',
    margin: '10px 0',
    color: '#fff',
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'center',
    letterSpacing: '1px',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 3px 6px rgba(0,0,0,0.4)',
  },
  aiButton: {
    backgroundColor: '#FFA042',
  },
};

export default Options;
